import { states, type State } from 'states-us';
export { type State } from 'states-us';

/** State utilities. */
export namespace StateUtils {

  /**
   * Makes state human-readable.
   * @param state State.
   */
  export function toReadable(state: State): string {
    return state.name;
  }

  /**
   * Comparator of state entities.
   * @param this This.
   * @param left State 1.
   * @param right State 2.
   */
  export function comparator(this: void, left: State, right: State): boolean {
    return left.abbreviation === right.abbreviation;
  }

  /**
   * State filter.
   * @param searchString Search str.
   */
  export function filter(searchString: string): State[] {
    const lowerCaseSearchString = searchString.toLocaleLowerCase();
    return states.filter(state =>
      state.name.toLocaleLowerCase().includes(lowerCaseSearchString) ||
      state.abbreviation.toLocaleLowerCase().includes(lowerCaseSearchString));
  }

  /**
   * Finds state by abbreviation.
   * @param abbreviation State abbreviation.
   */
  export function findByAbbreviation(abbreviation: string): State | undefined {
    return states.find(state => state.abbreviation === abbreviation);
  }
}
